import api from './api';

export type BillingType = 'per_pallet' | 'per_sqft' | 'fixed_monthly';

export interface BillingRateConfig {
  id: number;
  clientId: number;
  billingType: BillingType;
  storageRatePerPallet: number | null;
  storageRatePerSqft: number | null;
  fixedMonthlyCharge: number | null;
  coldStorageRate: number | null;
  additionalStorageRate: number | null;
  additionalSpaceRatePerPallet: number | null;
  additionalSpaceRatePerSqft: number | null;
  sqftAssigned: number | null;
  handlingChargePerTon: number | null;
  hamaliChargePerTon: number | null;
  packingChargePerUnit: number | null;
  labelChargePerUnit: number | null;
  stickerChargePerUnit: number | null;
  effectiveFrom: string;
  effectiveTo: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export type CreateBillingConfigPayload = Omit<
  BillingRateConfig,
  'id' | 'effectiveTo' | 'isActive' | 'createdAt' | 'updatedAt'
>;

export type UpdateBillingConfigPayload = Partial<
  Omit<BillingRateConfig, 'id' | 'clientId' | 'effectiveTo' | 'isActive' | 'createdAt' | 'updatedAt'>
>;

export const billingConfigService = {
  createConfig: async (payload: CreateBillingConfigPayload): Promise<BillingRateConfig> => {
    const response = await api.post('/billing-configs', payload);
    return (response as any).data;
  },

  // A client can hold up to 3 concurrently active configs — one per billing type.
  getActiveConfigs: async (clientId: number): Promise<BillingRateConfig[]> => {
    const response = await api.get(`/billing-configs/active?clientId=${clientId}`);
    return (response as any).data;
  },

  getConfigHistory: async (clientId: number): Promise<BillingRateConfig[]> => {
    const response = await api.get(`/billing-configs/history/${clientId}`);
    return (response as any).data;
  },

  updateConfig: async (id: number, payload: UpdateBillingConfigPayload): Promise<BillingRateConfig> => {
    const response = await api.patch(`/billing-configs/${id}`, payload);
    return (response as any).data;
  },
};
